/* eslint-disable no-underscore-dangle */
import React from 'react';
import 'assets/css/reportingPageStyle.css';

import {
  Checkbox, Popover, Icon, Button, Row, Col, Divider,
} from 'antd';
import { SpH5 } from 'components/DesignKit';

class CheckboxMenu extends React.Component {
  state = {
    icon: {},
    selectedItems: [],
    defaultBackgroundColor: '#fbfbfb',
  };

  componentDidMount = () => {
    if (this.props.value && this.props.value.length) {
      this.setState(
        {
          selectedItems: [...this.props.value],
        },
        () => this.checkIconFilled(),
      );
    }
  };

  onChange = selection => {
    this.setState({ selectedItems: [...selection] }, () => {
      this.checkIconFilled();
    });

    return this.props.onChange(selection);
  };

  checkIconFilled = () => {
    if (this.state.selectedItems.length) {
      this.setState({ icon: { theme: 'filled' } });
    } else {
      this.setState({ icon: {} });
    }
  };

  changeBackgroundColor = () => {
    if (this.state.defaultBackgroundColor === '#fbfbfb') {
      this.setState({ defaultBackgroundColor: '#e0e0e0' });
    } else {
      this.setState({ defaultBackgroundColor: '#fbfbfb' });
    }
  };

  updateAllSelectedItem = () => {
    this.setState({ selectedItems: [...this.props.options] }, () => {
      this.checkIconFilled();
    });

    return this.props.onChange(this.props.options);
  };

  unSelectedAllSelectedItem = () => {
    this.setState({ selectedItems: [] }, () => {
      this.checkIconFilled();
    });

    return this.props.onChange([]);
  };

  checkboxRender = () => {
    const _this = this;

    const groups = this.props.options
      .map((e, i) => (i % 10 === 0 ? _this.props.options.slice(i, i + 10) : null))
      .filter((e) => e);

    return (
      <Checkbox.Group onChange={this.onChange} value={this.state.selectedItems}>
        <Row
          type="flex"
          style={{
            flexDirection: 'column',
            margin: '14px',
          }}
        >
          {groups.map((group, i) => (
            <Col
              key={`checkbox-group-${i}`}
              // span={Math.floor(24 / groups.length)}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'start',
                color: '#808080',
              }}
            >
              {group.map((label) => (
                <Checkbox
                  key={label}
                  value={label}
                  style={{
                    display: 'block',
                    marginBottom: '7px',
                    width: 'auto',
                    marginLeft: '0',
                    fontWeight: 'normal',
                    fontSize: '14px',
                  }}
                >
                  {label.toLowerCase().split('_').reduce((previousValue, currentValue) => {
                    const processedCurrentValue = currentValue.charAt(0).toUpperCase() + currentValue.substring(1);
                    return `${previousValue} ${processedCurrentValue}`;
                  }, '')}
                </Checkbox>
              ))}
            </Col>
          ))}
        </Row>
        {/* <span>&nbsp;</span> */}
        <Divider style={{ margin: '5px 0' }} />
        <span
          style={{
            display: 'block',
            fontSize: '14px',
            cursor: 'pointer',
            fontWeight: 'normal',
            margin: '7px 15px 7px',
            minHeight: '20px',
            color: '#808080',
          }}
          onClick={() => { this.props.searchAll(); this.updateAllSelectedItem(); }}
        >
          Search all
        </span>
        <Divider style={{ margin: '5px 0' }} />
        <span
          style={{
            display: 'block',
            fontSize: '14px',
            cursor: 'pointer',
            fontWeight: 'normal',
            margin: '7px 15px 7px',
            minHeight: '20px',
            color: '#808080',
          }}
          onClick={() => { this.props.clearAll(); this.unSelectedAllSelectedItem(); }}
        >
          Clear all
        </span>
      </Checkbox.Group>
    );
  };

  render() {
    const CheckboxRender = this.checkboxRender;
    return (
      <Popover
        // id="reporting_summary_popover"
        content={<CheckboxRender />}
        trigger="click"
        placement="bottomLeft"
        onVisibleChange={this.changeBackgroundColor}
        overlayStyle={{
          marginTop: '0',
          paddingTop: '0',
        }}
        overlayClassName="reporting_summary_popover"
        // getPopupContainer={triggerNode => triggerNode.parentNode}
      >
        <Button
          size="large"
          type="primary"
          style={{
            borderRadius: 0,
            borderWidth: 0,
            backgroundColor: this.state.defaultBackgroundColor,
            color: '#414141',
            height: 'auto',
            minWidth: '100px',
            maxWidth: '150px',
            minHeight: '40px',
            boxShadow: 'none',
          }}
        >
          <SpH5 color="#414141" fontWeight="bold">{this.props.title}</SpH5> <Icon type="caret-down" {...this.state.icon} />
        </Button>
      </Popover>
    );
  }
}

export default CheckboxMenu;
